<template>
    <div :class="headerClass">
        <div class="grid-container">
            <div class="nav--holder grid-x grid-x-padding align-middle">
                <nav class="nav cell small-12">
                    <div class="button_menu--holder">
                        <button type="button" name="button_menu" :class="buttonMenuClass" v-on:click="toggleMenu">
                            <svg class="icon icon-open-button"><use xlink:href="#icon-open-button"></use></svg>
                            <span class="button_menu--label">MENU</span>

                            <svg class="icon icon-close-button"><use xlink:href="#icon-close-button"></use></svg>
                        </button>
                    </div>

                    <div class="sns_block">
                        <ul class="grid-x align-middle align-center">
                            <li class="cell shrink">
                                <a href="https://www.instagram.com/netemosametemo_movie/" class="sns_block--link" title="Instagram" target="_blank"><svg class="icon icon-instagram"><use xlink:href="#icon-instagram"></use></svg></a>
                            </li>
                            <li class="cell shrink">
                                <a href="https://twitter.com/netesame_movie" class="sns_block--link" title="Twitter" target="_blank"><svg class="icon icon-twitter"><use xlink:href="#icon-twitter"></use></svg></a>
                            </li>
                            <li class="cell shrink">
                                <a href="https://www.facebook.com/netemosametemo.movie/" class="sns_block--link" title="Facebook" target="_blank"><svg class="icon icon-facebook"><use xlink:href="#icon-facebook"></use></svg></a>
                            </li>
                        </ul>
                    </div>

                    <ul :class="menuClass">
                        <li class="cell shrink">
                            <a href="#top" title="Top" v-smooth-scroll="{ duration: 1000 }" @click="closeMenu()">TOP</a>
                        </li>
                        <li class="cell shrink">
                            <a href="#introduction" title="イントロダクション" v-smooth-scroll="{ duration: 1000 }" @click="closeMenu()">イントロダクション</a>
                        </li>
                        <li class="cell shrink">
                            <a href="#films" title="上映作品" v-smooth-scroll="{ duration: 1000 }" @click="closeMenu()">上映作品</a>
                        </li>
                        <li class="cell shrink">
                            <a href="#theater" title="劇場" v-smooth-scroll="{ duration: 1000 }" @click="closeMenu()">劇場</a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'navigation',
    data () {
        return {
            showMenu: false
        }
    },

    computed: {
        headerClass () {
            if (this.showMenu) {
                return 'navigation fade_in_intro is-active'
            } else {
                return 'navigation fade_in_intro'
            }
        },
        menuClass () {
            if (this.showMenu) {
                return 'grid-x menu align-center is-active'
            } else {
                return 'grid-x menu align-center'
            }
        },
        snsClass () {
            if (this.showMenu) {
                return 'sns_menu cell shrink is-active'
            } else {
                return 'sns_menu cell shrink'
            }
        },
        buttonMenuClass () {
            if (this.showMenu) {
                return 'button_menu is-active'
            } else {
                return 'button_menu'
            }
        }
    },

    methods: {
        toggleMenu () {
            if (this.showMenu) {
                this.showMenu = false
            } else {
                this.showMenu = true
            }
        },
        closeMenu () {
            this.showMenu = false
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue